<template>
    <div>
        <div class="flex pb-2" v-if="isLevelSliver">
            <img class="ml-auto mr-1 my-auto" src="@/assets/icon/crown-silver.svg" />
            <div class="ml-1 mr-auto my-auto text-14 text-a-silver-9b9b9b">{{getPointText(FilterNumberFormat(userPoint))}}</div>
        </div>
        <div class="flex pb-2" v-if="isLevelGold">
            <img class="ml-auto mr-1 my-auto" src="@/assets/icon/crown-yellow.svg" />
            <div class="ml-1 mr-auto my-auto text-14 text-a-yellow-e8af25">{{getPointText(FilterNumberFormat(userPoint))}}</div>
        </div>
        <div class="flex pb-2" v-if="isLevelPlatinum">
            <img class="ml-auto mr-1 my-auto" src="@/assets/icon/crown-platinum.svg" />
            <div class="ml-1 mr-auto my-auto text-14 text-a-platinum-8f97b0">{{getPointText(FilterNumberFormat(userPoint))}}</div>
        </div>
        <div class="flex pb-2" v-if="isLevelDiamond">
            <img class="ml-auto mr-1 my-auto" src="@/assets/icon/crown-diamond.svg" />
            <div class="ml-1 mr-auto my-auto text-14 text-a-red-d62300">{{getPointText(FilterNumberFormat(userPoint))}}</div>
        </div>
        <div class="text-center font-bold text-18 pb-2 text-a-brown-502314">
            {{getLevelText(profileLevel?.currentLevel)}}
        </div>
    </div>
</template>

<script>
import Util from '@/helper/Utility';
//mixin
import AuthStatusMixin from '@/mixin/AuthStatusMixin'
import ProfilePointMixin from '@/mixin/ProfilePointMixin';
import ModalMixin from '@/mixin/ModalMixin';
import LocaleMixin from "@/mixin/LocaleMixin.js";
export default {
    name: "EarnPointLevel",
    mixins: [AuthStatusMixin, ModalMixin, ProfilePointMixin, LocaleMixin],
    data: function () {
        return {
            profileLevel: null,
        };
    },
    methods: {
        onAccountInit: function () {
            this.getUserLevelInfo();
        },
        getUserLevelInfo: function () {
            // ProfilePointMixin
            this.getProfileLevel().then((data) => {
                this.profileLevel = data;
            }).catch((err) => {
                this.errorApi(err);
            });
        },

        getPointText: function (point) {
            return Util.stringFormat(this.lbl.earnpoint.have_crowns,point);
        },

        getLevelText: function (level) {
            return Util.stringFormat(this.lbl.earnpoint.whopper_level,level);
        }
    }
}
</script>

<style>

</style>
